import { render, staticRenderFns } from "./qrOXXO.vue?vue&type=template&id=2ad9710f&scoped=true&"
import script from "./qrOXXO.vue?vue&type=script&lang=js&"
export * from "./qrOXXO.vue?vue&type=script&lang=js&"
import style0 from "./qrOXXO.vue?vue&type=style&index=0&id=2ad9710f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad9710f",
  null
  
)

export default component.exports